<!--  -->
<template>
    <div v-show="visible" class="resume-dialog-detain">
        <div class="detain-container">
            <div class="detain-title">提示</div>
            <div class="detain-info">遇到喜欢的工作不容易，真的不再争取下嘛？</div>
            <ul class="detain-control">
                <li @click="close">确认退出</li>
                <li @click="cancel">继续填写</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {visible: false};
    },
    computed: {},
    mounted() {
        document.body.appendChild(this.$el);
        // if (window.history && window.history.pushState) {
        //     history.pushState(null, null, document.URL);
        //     window.addEventListener('popstate', this.handlerDetain, false);
        // }
    },
    // destroyed() {
    //     window.removeEventListener('popstate', this.handlerDetain, false);
    // },
    methods: {
        show() {
            this.visible = true;
        },
        cancel() {
            this.visible = false;
            this.$root.cbProcess && this.$root.cbProcess({ action: 1003, type: 'new_resume_wait_continue' });
        },
        close() {
            this.visible = false;
            this.$root.cbProcess && this.$root.cbProcess({ action: 1003, type: 'new_resume_wait_sure' });
            this.$emit('close');
        }
    }
};
</script>
